const sortedFeaturesByIncludedFeaturesCount = ({ currentOffer }) => {
  const features = currentOffer?.features;
  const plans = currentOffer?.plans;

  if (!features || !plans) {
    return [];
  }

  /**
   *
   * @type {{featureId: number, includedFeatureCount: number}[]}
   */
  const includedFeaturesCount = [];

  for (const feature of features) {
    let includedFeatureCount = 0;

    for (const { included_features } of plans) {
      const hasFeature = included_features.find(({ id }) => {
        return id === feature.id;
      });

      if (!hasFeature) {
        includedFeatureCount += 1;
      }
    }

    includedFeaturesCount.push({
      featureId: feature.id,
      includedFeatureCount
    });
  }

  includedFeaturesCount.sort(
    (a, b) => a.includedFeatureCount - b.includedFeatureCount
  );

  const sortedFeatures = [];

  for (const { featureId } of includedFeaturesCount) {
    const feature = features.find(({ id }) => id === featureId);

    if (feature) {
      sortedFeatures.push(feature);
    }
  }

  return sortedFeatures;
};

export default sortedFeaturesByIncludedFeaturesCount;
